import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { FaBars, FaSignOutAlt } from 'react-icons/fa';

export default function Header({ toggleSidebar, isSidebarOpen }) {
  const navigate = useNavigate();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = () => {
    // Clear admin authentication data
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminId');
    localStorage.removeItem('userRole');
    sessionStorage.removeItem('adminToken');
    sessionStorage.removeItem('adminId');
    sessionStorage.removeItem('userRole');
    
    // Redirect to admin login
    navigate('/admin/login');
  };

  return (
    <div className="d-flex justify-content-between align-items-center px-4 py-3 db1-header">
      <div className="d-flex align-items-center">
        {!isSidebarOpen && (
          <Button
            variant="light"
            onClick={toggleSidebar}
            className="d-md-none border-0 p-2 me-3 d-flex align-items-center justify-content-center"
            style={{ borderRadius: '12px', minWidth: '40px', height: '40px', background: 'rgba(172,46,98,0.06)' }}
          >
            <FaBars style={{ color: '#ac2e62', fontSize: '18px' }} />
          </Button>
        )}
        <div>
          <h5 className="mb-0 fw-bold" style={{ color: '#2c3e50', fontSize: '1.1rem', letterSpacing: '-0.3px' }}>
            Dashboard
          </h5>
          <p className="mb-0" style={{ color: '#ac2e62', fontSize: '0.7rem', fontWeight: 600, opacity: 0.7, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
            Visitor Management
          </p>
        </div>
      </div>
      <Button
        variant="outline-danger"
        size="sm"
        onClick={handleLogout}
        className="d-flex align-items-center gap-2"
        style={{
          borderRadius: '999px',
          padding: '8px 20px',
          fontSize: '0.82rem',
          fontWeight: 600,
          border: '1px solid rgba(220,53,69,0.15)',
          color: '#dc3545',
          background: 'rgba(220,53,69,0.04)',
          transition: 'all 0.2s ease'
        }}
      >
        <FaSignOutAlt style={{ fontSize: '13px' }} />
        Logout
      </Button>
    </div>
  );
}
